export default {
  homePage: "Página principal",
  close: "Cerrar",
  bestSelling: "Más vendidos",
  seeAllProduct: "Ver todos los productos",
  quickView: "Vista rápida",
  addToWishlist: "Añadir a la lista de deseos",
  addToCompare: "Añadir para comparar",
  compare: "Comparar",
  addToCart: "Añadir al carrito",
  searchTitle: "Buscar",
  searchButton: "Buscar",
  searchPlaceholder: "Buscar aquí...",
  checkout: "Finalizar compra",
  viewCart: "Ver carrito",
  subtotal: "Subtotal",
  cartQuantity: "Carrito ({count})",
  filter: "Filtrar",
  sortby: "Ordenar por",
  showFilters: "Mostrar filtros",
  collection: "Colección",
  category: "Categoría",
  materials: "Materiales",
  stones: "Piedras",
  viewResult: "Ver resultado",
  relatedProducts: "Productos relacionados",
  nextBtn: "Siguiente",
  prevBtn: "Anterior",
  byAuthor: "Por {author}",
  articles: "Artículos",
  allArticles: "Todos los artículos",
  recentlyViewed: "Visto recientemente",
  backTohomepage: "Volver a la página principal",
  text404: "Es probable que esta página haya sido movida a otro lugar.",
  latestArticles: "Últimos artículos",
  all: "todos",
  searchInBlog: "Buscar en el blog",
  shopCategories: "Categorías de la tienda",
  shopNow: "Comprar ahora",
  status: "Estado",
  buyNow: "Comprar ahora",
  back: "Atrás",
  forgotPassword: "¿Olvidaste tu contraseña?",
  emailAddressPlaceholder: "Correo electrónico",
  passwordPlaceholder: "Contraseña",
  firstNamePlaceholder: "Nombre",
  lastNamePlaceholder: "Apellido",
  submit: "Enviar",
  signIn: "Iniciar sesión",
  signOut: "Cerrar sesión",
  createAccount: "Crear una cuenta",
  forgotTitle: "Restablece tu contraseña",
  forgotDesc:
    "Introduce la dirección de correo electrónico asociada a tu cuenta. Haz clic en enviar para recibir tu contraseña por correo electrónico.",
  loginTitle: "Clientes existentes",
  loginDesc: "Inicia sesión en tu cuenta a continuación:",
  registerTitle: "Nuevos clientes",
  registerDesc: "Crea una cuenta a continuación:",
  profile: "Perfil",
  myOrders: "Mis pedidos",
  wishlist: "Lista de deseos",
  addedToWishlist: "Añadido a la lista de deseos",
  compared: "Comparado",
  product: "Producto",
  price: "Precio",
  qty: "Cantidad",
  edit: "Editar",
  cartEmpty: "Carrito vacío",
  discountCode: "Código de descuento",
  discountCodePlaceholder: "Introduce el código promocional",
  applyCoupon: "Aplicar cupón",
  orderSummary: "Resumen del pedido",
  total: "Total",
  proceedToCheckout: "Proceder al pago",
  acceptPaymentMethods: "Métodos de pago aceptados",
  continueShopping: "Seguir comprando",
  shoppingCart: "Carrito de compras",
  companyPlaceholder: "Nombre de la empresa",
  streetAddressPlaceholder: "Dirección",
  cityPlaceholder: "Ciudad",
  zipCodePlaceholder: "Código postal",
  phoneNumberPlaceholder: "Número de teléfono",
  shipToDifferentAddress: "¿Enviar a una dirección diferente?",
  orderNotePlaceholder: "Nota del pedido (opcional)",
  privacyText:
    "Tus datos personales se usarán para procesar tu pedido, apoyar tu experiencia en este sitio web y otros fines descritos en nuestra",
  privacyPolicy: "Política de privacidad",
  returnPolicy: "Política de devoluciones",
  placeOrder: "Realizar pedido",
  yourOrder: "Tu pedido",
  billingDetail: "Detalles de facturación",
  apply: "Aplicar",
  logInYourAccount: "Inicia sesión en tu cuenta",
  shopByTheLook: "Compra por estilo",
  instagramBlockSubtitle: "Síguenos en Instagram o etiquétanos con",
  thanksOrder: "¡Gracias por tu pedido!",
  orderCompleteDesc:
    "Estamos preparando tu pedido para ser enviado. Te notificaremos cuando haya sido enviado.",
  orderNumber: "Número de pedido",
  customerInformation: "Información del cliente",
  shippingAddress: "Dirección de envío",
  billingAddress: "Dirección de facturación",
  customerDetails: "Detalles del cliente",
  deliveryDetail: "Detalles de entrega",
  needHelp: "¿Necesitas ayuda? Contáctanos",
  policyBanner:
    "Este sitio web utiliza cookies para garantizar que obtengas la mejor experiencia.",
  gotIt: "Entendido",
  acceptFor: "Aceptar para",
  subscribe: "Suscribirse",
  bySubscribingYouAcceptThe: "Al suscribirte, aceptas la",
  beTheFirstToGetTheLatestNewsAboutTrendsPromotionsAndMuchMore:
    "¡Sé el primero en recibir las últimas noticias sobre tendencias, promociones y mucho más!",
  newsletter: "Boletín",
  omara: "OMARA",
  home: "Inicio",
  youHaveSuccessfullySubscribed: "Te has suscrito con éxito",
  noData: "Sin datos",
  noImages: "Sin imágenes",
  success: "Éxito",
  error: "Error",
  serverError: "Error del servidor",
  confirmMessage:
    "El registro fue exitoso, sigue las instrucciones en el correo electrónico que te enviamos.",
  recoverPasswordMessage:
    "Formulario enviado con éxito, sigue las instrucciones en el correo electrónico que te enviamos.",
  emailVerifySuccess: "Tu correo electrónico ha sido verificado con éxito",
  passwordRecoverySuccess: "Tu contraseña ha sido restaurada con éxito",
  passwordUpdateSuccess: "Tu contraseña ha sido actualizada con éxito",
  loading: "Cargando",
  blogPageTitle: "Nuestro Diario",
  blogPageDescription:
    "Existen muchas variaciones de textos de Lorem Ipsum disponibles, pero la mayoría han sufrido alteraciones en alguna forma.",
  passwordRecovery: "Recuperación de contraseña",
  pleaseFillTheForm: "Por favor completa el formulario",
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Confirmar nueva contraseña",
  recover: "Recuperar",
  catalog: "Catálogo",
  showMore: "Mostrar más",
  showLess: "Mostrar menos",
  shipping: "Envío",
  shippingDetail: "Detalles del envío",
  free: "Gratis",
  directBankTransfers: "Transferencias bancarias directas",
  giftCard: "Tarjeta de regalo",
  giftCardAmount: "Monto de la tarjeta de regalo",
  discount: "Descuento",
  view: "Ver",
  expressCheckout: "Pago rápido",
  or: "o",
  allTransactionsAreSecureAndEncrypted:
    "Todas las transacciones son seguras y están encriptadas.",
  yourOrderIsFree: "Tu pedido es gratuito, no se requiere pago.",
  payment: "Pago",
  change: "Cambiar",
  shipTo: "Enviar a",
  contact: "Contacto",
  completeOrder: "Completar pedido",
  estimateDeliveryDate: "Fecha estimada de entrega",
  yourMessageIsSent: "Tu mensaje ha sido enviado",
  weWillGetBackToYouWithAnAnswerAsSoonAsPossible:
    "Nos pondremos en contacto contigo con una respuesta lo antes posible.",
  email: "Correo electrónico",
  birthday: "Cumpleaños",
  save: "Guardar",
  changeUserInfoText: "Información del usuario actualizada",
  updatePassword: "Actualizar contraseña",
  currentPassword: "Contraseña actual",
  changeUserPasswordText: "Contraseña del usuario actualizada",
  yourEmailPreferences: "Tus preferencias de correo electrónico",
  selectWhichEmailsYouWouldLikeToReceive:
    "Selecciona los correos que te gustaría recibir:",
  changePassword: "Cambiar contraseña",
  updateEmailPreferences: "Actualizar preferencias de correo electrónico",
  dateOrdered: "Fecha del pedido",
  orderNo: "N.º de pedido",
  returns: "Devoluciones",
  orderTotal: "Total del pedido",
  orderDetails: "Detalles del pedido",
  paymentSummary: "Resumen de pago",
  discountCard: "Tarjeta de descuento",
  tax: "Impuesto",
  productDiscount: "Descuento del producto",
  paymentMethod: "Método de pago",
  deliveryAddress: "Dirección de entrega",
  shippingAddresses: "Direcciones de envío",
  addNewAddress: "Añadir nueva dirección",
  create: "Crear",
  editAddress: "Editar dirección",
  addressDeleted: "Dirección eliminada",
  deleteAddress: "Eliminar dirección",
  addressAdded: "Dirección añadida",
  addressEdited: "Dirección editada",
  orderTracking: "Seguimiento del pedido",
  estimatedDelivery: "Entrega estimada",
  completed: "Completado",
  inProgress: "En progreso",
  next: "Siguiente",
  textMeStatusUpdates: "Envíame actualizaciones por texto",
  collections: "Colecciones",
  fromPrice: "Desde {price}",
  enterPromoCode: "Introduce un código promocional",
  resetAll: "Restablecer todo",
  troubleCreateOrder:
    "Lo sentimos, actualmente hay dificultades para crear un pedido.",
  estimatedDeliveryDate: "Fecha estimada de entrega",
  orderNotes: "Notas del pedido",
  deliveryMethod: "Método de entrega",
  selectShippingMethod: "Selecciona un método de envío",
  filterTitles: {
    collections: "Colección",
    categories: "Categoría",
    materials: "Materiales",
    stones: "Piedras",
    headstyles: "Estilos de cabeza",
    stoneshapes: "Formas de piedras",
  },
  configurator: {
    item: "Artículo",
    startingAt: "Desde",
    total: "Total",
    addToBag: "Añadir al carrito",
    remove: "Eliminar",
    addItem: "Añadir artículo",
    characters: "Caracteres",
    yourDesign: "Tu diseño",
    openMap: "Selecciona en el mapa",
    latitude: "Latitud",
    longitude: "Longitud",
    clear: "Borrar",
    clearAll: "Borrar todo",
    addedToWishlist: "Añadido a la lista de deseos",
    addToWishlist: "Añadir a la lista de deseos",
    compare: "Comparar",
    addedToCompareList: "Añadido a la lista de comparación",
    size_guide: "Descubre tu tamaño",
    outOfStock: "Agotado",
    productDetails: "Detalles del producto",
  },
  estimated: "Estimado",
  days: "días",
  brand: "Marca",
  productDetails: "Detalles del producto",
  acceptAll: "Aceptar todo",
  selectACountry: "Selecciona un país",
  continue: "Continuar",
  shippingMethod: "Método de envío",
  finalizeAndPay: "Finalizar y pagar",
  createOrderErrorText:
    "Error al crear el pedido. Por favor, contacta al soporte al cliente.",
  createSessionErrorText: "Algo salió mal. Por favor, inténtalo de nuevo.",
  // Mollie payment error messages
  molliePaymentError: "Error al procesar el pago. Inténtalo de nuevo.",
  mollieInitError: "La inicialización del sistema de pago falló. Actualiza la página.",
  mollieScriptLoadError: "No se pudo cargar el sistema de pago. Verifica tu conexión a internet.",
  mollieCardTokenError: "La validación de la tarjeta falló. Verifica los datos de tu tarjeta.",
  mollieProfileIdError: "Error de configuración de pago. Contacta al soporte.",
  mollieInvalidFieldsError: "Uno o más campos son inválidos",
  mollieComponentsNotMountedError: "No todos los componentes requeridos están montados, consulta https://docs.mollie.com/guides/mollie-components/reference para más información.",
  paymentFailed: "El pago falló. Inténtalo de nuevo o usa otro método de pago.",
  paymentPending: "El pago se está procesando. Espera mientras procesamos tu pago.",
  paymentExpired: "La sesión de pago ha expirado. Inténtalo de nuevo.",
  cart: "Carrito",
  review: "Revisión",
  paymentStatus: "Estado del pago",
  unpaid: "No pagado",
  paid: "Pagado",
  refundStarted: "Reembolso iniciado",
  refunded: "Reembolsado",
  partiallyRefunded: "Parcialmente reembolsado",
  voided: "Anulado",
  fillTheFormBelow: "Completa el formulario a continuación",
  newClients: "Nuevos clientes",
  createMyAccount: "Crear mi cuenta",
  createAnAccountByClickingBelow: "Crea una cuenta haciendo clic abajo y obtén",
  percentOff: "{percent}% de descuento",
  yourFirstOrder: "tu primer pedido",
  yourCartIsEmpty: "Tu carrito está vacío",
  login: "Iniciar sesión",
  sorting: "Ordenar",
  priceFromLowestToHighest: "Precio de menor a mayor",
  priceFromHighestToLowest: "Precio de mayor a menor",
  defaultV: "por defecto",
  use: "Usar",
  notificationLanguage: "Idioma de notificaciones",
  onlinePayment: "Pago en línea",
  card: "Tarjeta",
  bankTransfer: "Transferencia bancaria",
  paymentMethodC: "Método de pago",
  bankTransferDisclaimer:
    "Recibirás un correo electrónico con todos los detalles necesarios para el pago.",
  stripeDisclaimer:
    "Tu información de pago es procesada de forma segura por <a href='https://stripe.com/es/resources/more/secure-payment-systems-explained' target='_blank'>Stripe</a>. No almacenamos los datos de tu tarjeta.",
  mollieDisclaimer:
    "Tu información de pago es procesada de forma segura por <a href='https://www.mollie.com/en/security' target='_blank'>Mollie</a>. No almacenamos los datos de tu tarjeta.",
  selectJewelry: "Seleccionar joyería",
  nextStep: "Siguiente paso",
  gold: "Oro",
  platinum: "Platino 950",
  silver: "Plata 925",
  goldOverSilver: "Oro sobre plata",
  recommended: "Recomendado",
  thePerfectComplement: "El complemento perfecto",
  description: "Descripción",
  shipReturn: "Envío y devoluciones",
  askAQuestion: "Preguntas frecuentes",
  closePopup: "Cerrar ventana emergente",
  closeFilter: "Cerrar filtro",
  toggleMenu: "Alternar menú",
  removeFromComparison: "Eliminar de la comparación",
  removeFromWishlist: "Eliminar de la lista de deseos",
  closeCartDrawer: "Cerrar carrito",
  removeDiscount: "Eliminar descuento",
  openFilePreview: "Abrir vista previa de archivo",
  closeSearchPopup: "Cerrar ventana de búsqueda",
  closeModal: "Cerrar modal",
  removeCartItem: "Eliminar del carrito",
  ariaGoToSlide: "Ir a la diapositiva {index}",
  ariaPrevSlide: "Diapositiva anterior",
  ariaNextSlide: "Siguiente diapositiva",
  viewThePhotoOnInstagram: "Ver la foto en Instagram",
  ariaViewProduct: `Ver producto {title}`,
  ariaBackTo: `Volver a {title}`,
  thankYouForSubscription: "Gracias por suscribirte",
  thankYouForSubscribingExploreOurExclusiveJewelryCollectionsAndStayTunedForUpdates:
    "¡Gracias por suscribirte! Explora nuestras exclusivas colecciones de joyas y mantente al tanto de las novedades.",
  startShoppingNow: "Comienza a comprar ahora",
  didntReceiveYourEmail: "¿No recibiste tu correo electrónico?",
  checkYourSpamFolderOrContactOurSupport:
    "Revisa tu carpeta de spam o <a href='mailto:info@omara.sk'>contacta a nuestro soporte</a>.",
  dontHaveAnAccountSignUp: "¿No tienes una cuenta? Regístrate",
  alreadyHaveAnAccountLogIn: "¿Ya tienes una cuenta? Inicia sesión",
  bannerImage: "Imagen de banner",
  outOfStock: "Agotado",
  requestPrice: "Solicitar precio",
  continueWith: "Continuar con {title}",
  orSignIn: "O inicia sesión",
  orSignUp: "O regístrate",
  remove: "Eliminar",
  discountCodeAndGiftCardsNotice:
    "<span class='tw-font-semibold'>Códigos de descuento:</span> Solo puedes aplicar un código por pedido.<br><div class='pt-1'><span class='tw-font-semibold'>Tarjetas de regalo:</span> Los códigos de descuento se pueden usar con múltiples tarjetas de regalo por pedido.</div>",
  yourAccountHasBeenSuccessfullyCreated: "Tu cuenta ha sido creada con éxito",
  watch: "Ver",
  returnItems: "Sin devoluciones | Devolver artículo | Devolver artículos",
  requestReturn: "Solicitar devolución",
  cancel: "Cancelar",
  refundType: "Tipo de reembolso",
  writeAFewWords: "Escribe unas palabras",
  reason: "Motivo",
  selectReason: "Seleccionar motivo",
  additionalComment: "Comentario adicional",
  returnAndRefund: "Devolución y reembolso",
  repairResize: "Reparar/ajustar",
  returnRequested: "Devolución solicitada",
  phonePlaceholder: "+421XXXXXXXXX",
  send: "Enviar",
  name: "Nombre",
  campaignsTarget: "Objetivo de campañas",
  additionalDetails: "Detalles adicionales",
  paymentCanceled: "Pago cancelado",
  paymentTimeoutMessage:
    "El pago está tardando más de lo esperado. Por favor, inténtalo de nuevo.",
  payNow: "Pagar ahora",
  discountCodeIsIncorrect: "El código de descuento es incorrecto",
  continueWithoutDiscount: "Continuar sin descuento",
  yes: "Sí",
  no: "No",
  search: "Buscar",
  readTheArticle: "Leer artículo",
  nextArticle: "Siguiente artículo",
  topSuggestions: "Principales sugerencias",
  noResultsFound: "No se encontraron resultados",
  noResultsFoundText: "Lo sentimos, tu búsqueda no devolvió ningún resultado. Intenta con otro término o contáctanos para obtener ayuda",

  // Size to weight translations
  stoneSizeInMm: "Tamaño de la piedra (mm)",
  caratWeight: "Peso en quilates (ct)",
  selectSize: "Seleccionar tamaño",
  millimetersMmToCaratWeight: "milímetros a peso en quilates",
  hideMmToCaratWeightChart: "Ocultar tabla mm a quilates",
  showMmToCaratWeightChart: "Mostrar tabla mm a quilates",
  mMSize: "Tamaño en mm",

  // Diamond shapes
  roundCut: "Corte Redondo",
  round: "Redondo",
  princessSquareCut: "Corte Princess",
  princess: "Princess",
  asscherCut: "Corte Asscher",
  asscher: "Asscher",
  cushionCut: "Corte Cojín",
  cushion: "Cojín",
  ovalCut: "Corte Ovalado",
  oval: "Ovalado",
  radiantCut: "Corte Radiante",
  radiant: "Radiante",
  pearCut: "Corte Pera",
  pear: "Pera",
  heartCut: "Corte Corazón",
  heart: "Corazón",
  marquiseCut: "Corte Marquesa",
  marquise: "Marquesa",
  triangleCut: "Corte Triangular",
  triangle: "Triángulo",
  trillionCut: "Corte Trillion",
  trillion: "Trillion",
  baguetteStraightCut: "Corte Baguette",
  baguette: "Baguette",
  baguetteTaperedCut: "Corte Tapered Baguette",
  taperedBaguette: "Tapered Baguette",
  emeraldCut: "Corte Esmeralda",
  emerald: "Esmeralda",
  articleDescription: "Los últimos artículos sobre",
  ourBlog: "Nuestro Blog",
  freeShippingByDate: "Envío gratis hasta el <span class='tw-font-normal'>{date}</span> si lo pides hoy",
  freeDaysReturns: "Devolución gratis durante {days} días",
  shippingDateNotAvailable: "Fecha no disponible",
  certificateIssuer: "Emisor del certificado",
  certificateUrl: "URL del certificado",
  // Mollie card form labels and placeholders
  cardHolderName: "Nombre",
  cardNumber: "Número de tarjeta",
  expiryDate: "Fecha de vencimiento",
  cvc: "CVC",
  enterCardholderName: "Ingrese el nombre del titular",
  cardNumberPlaceholder: "1234 1234 1234 1234",
  expiryDatePlaceholder: "MM/AA",
  cvcPlaceholder: "123",
  finalSale: "Venta Final",
  nonRefundable: "No reembolsable",
  youMightAlsoLike: "También te puede gustar",
  reviews: "Reseñas",
  reviewsCount: "sin reseñas | {count} reseña | {count} reseñas",
  reviewsRecommend: "Sí, lo recomendaría a un amigo",
  reviewsStars: "sin estrellas | {count} estrella | {count} estrellas",
};
